import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { SuiModal } from '@splashthat/sui';

import {
    openFormTemplateLibrary,
    closeFormTemplateLibrary,
    fetchApiQuestions,
    loadApiQuestions,
    setFormTemplateLibraryView,
} from '../../actions/templateLibrary';
import { getAlreadyAddedUniqueNames, getFormId } from '../../selectors';
import { getIsOpen, getIsLoadingTemplateLibrary, getActiveTab } from '../../selectors/templateLibrary';

import FormTemplateLibrary from './FormTemplateLibrary';

class FormTemplateLibraryModal extends Component {
    static propTypes = {
        open: PropTypes.bool.isRequired,
        closeFormTemplateLibrary: PropTypes.func.isRequired,
    };

    render() {
        return (
            <SuiModal
                open={this.props.open}
                size={SuiModal.MEDIUM}
                useClickOutside
                onRequestClose={this.props.closeFormTemplateLibrary}
            >
                {this.props.open && <FormTemplateLibrary {...this.props} />}
            </SuiModal>
        );
    }
}

const mapStateToProps = (state) => {
    const open = getIsOpen(state);
    const isLoadingTemplateLibrary = getIsLoadingTemplateLibrary(state);
    const formId = getFormId(state);
    const alreadyAddedUniqueNames = formId ? getAlreadyAddedUniqueNames(state, formId) : [];
    const activeTab = getActiveTab(state);

    return {
        open,
        isLoadingTemplateLibrary,
        alreadyAddedUniqueNames,
        activeTab,
    };
};

const mapDispatchToProps = {
    openFormTemplateLibrary,
    closeFormTemplateLibrary,
    fetchApiQuestions,
    loadApiQuestions,
    setFormTemplateLibraryView,
};

export default connect(mapStateToProps, mapDispatchToProps)(FormTemplateLibraryModal);
